import React, { useState, createRef, useEffect } from "react";

import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2'
import config from "../../config"


const Forgot_password = () => {
  const location = useLocation();
  let navigate =useNavigate();
 
 
  const [state, setState] = React.useState({ email: location.state.email,otp:""  })
  const initialTimeInSeconds = 120; // 2 minutes
  const [timeLeft, setTimeLeft] = useState(initialTimeInSeconds);
  const [timerActive, setTimerActive] = useState(true);
  const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000
  });

  useEffect(() => {
    let timerInterval;

    if (timerActive) {
        timerInterval = setInterval(() => {
            if (timeLeft > 0) {
                setTimeLeft((prevTime) => prevTime - 1);
            } else {
                setTimerActive(false); // Timer has reached 0, so deactivate it
            }
        }, 1000);
    }

    return () => {
        clearInterval(timerInterval);
    };
}, [timeLeft, timerActive]);

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

  const axios_registration_api = (event) => {
      // event.preventDefault();
      if (state.email != '' && state.otp!="") {
        let full_api = config.apiUrl + `/user/forgot_otp_verification`;
       let sendData = { email: state.email, otp: state.otp  };
      
        axios.post(full_api, sendData, { headers: config.headers }).then((res) => {
      
      if(res.data.status==true){
         
          let sendState = { email:state.email};
         Toast.fire({
             background:"#3659cd",
             type: 'success',
             title: res.data.message ,
             color:"white"
           });
           setTimeout(()=>{
             navigate('/create_password' , {state:sendState})
           },2000)
         }
         else{
          Toast.fire({
              background:"#a61c09",
              type: 'unsuccess',
              title: res.data.message ,
              color:"white"
            });
         }
          
        }).catch((e) => {
         
        });
      }
    };
    const handleChangeBroker = (event) => {
      setState({
               ...state,
               [event.target.name]: event.target.value,
             });

    }
    const handleResendClick = () => {
      // Reset the timer and make it active again
      setTimeLeft(initialTimeInSeconds);
      setTimerActive(true);
      let full_api = config.apiUrl + `/user/forgot_otp_resend`;
      // let fullOtp = state.otp1+""+state.otp2+""+state.otp3+""+state.otp4+""+state.otp5+""+state.otp6
       let sendData = { email: state.email, otp: state.otp };
       // console.log(sendData);
       axios.post(full_api, sendData, { headers: config.headers }).then((res) => {
         // console.log(res);
         if (res.data.status == true) {
          Toast.fire({
              background:"#3659cd",
              type: 'success',
              title: res.data.message ,
              color:"white"
            });
            let sendState = { mobile_number:sendData.mobile_number};
            // console.log("sendState === " , sendState)
          
          //    navigate('/customer/verify_sms',{state:sendState})
         }else {
          Toast.fire({
              background:"#a61c09",
              type: 'success',
              title: res.data.message ,
              color:"white"
            });
         }
         
       }).catch((e) => {
         //setState({...state,isLoading: false});

         // toast.configure();
         // toast.error("Some thing went wrong");
         // // console.log("----error:   ", e);
       });
  };
  return (
    <div>
    

<section class="register_box_00">
  <div class="row justify-content-center ">
    <div class="col-xl-4 col-lg-5 col-sm-6 col-12 ">
      <form onSubmit={(e) => {
          e.preventDefault(); // Prevent the default form submission behavior
          axios_registration_api(); // Call your login function
        }} class="my-5">
        <div class="border rounded-2 p-4 mt-5 login_box">
          <div class="login-form">
            <div class="text-center login-logo">
              <a href="/login" class="mb-4 text-center">
                <img src="assets/images/logo_big.png" class="img-fluid " alt=""/>
                <h3 class="fw-bold"></h3>
              </a>
            </div>
            <h5 class="fw-bold">OTP Verification</h5>
            <p class="">We have sent an OTP to your email. Please check your Email Inbox or Spam folder and confirm it.</p>
            <small> Didn't receive OTP? {timerActive ? (
                                         <span id="resendTimer">Resend OTP in {formatTime(timeLeft)} </span>
                                     ) : (
                                         <button onClick={handleResendClick} className="btn btn-primary">Resend OTP</button>
                                     )}</small>
            <div class="mb-5">
              <label class="form-label">Confirm OTP</label>
              <input type="text" class="form-control" placeholder="Enter OTP sent your email address" name="otp" onChange={(e)=>handleChangeBroker(e)}/>
            </div>
            <div class="d-grid py-3 mt-4">
              <button  type="submit"  style={{cursor:"pointer"}} class="btn btn-lg btn-primary">
                Confirm OTP
              </button>
            </div>
            <div class="text-center pt-4">
              <a href="/login" class="text-blue text-decoration-underline ms-2">
                Retrun to login</a>
            </div>
          </div>
        </div>
      </form>

      <div class="text-center mt-3">
  <ul class="nav justify-content-center">
    <li class="nav-item"><a class="nav-link px-2" href="/cancellation_and_refund_policy" target="_blank">Cancellation &amp; Refund Policy</a></li>
    <li class="nav-item"><a class="nav-link px-2" href="/terms" target="_blank">Terms &amp; Condition</a></li>
    <li class="nav-item"><a class="nav-link px-2" href="/policy" target="_blank">Privacy Policy</a></li>
    <li class="nav-item"><a class="nav-link px-2" href="/shipping_policy" target="_blank">Shipping Policy</a></li>
    <li class="nav-item"><a class="nav-link px-2" href="/contact" target="_blank">Contact Us</a></li>
  </ul>
</div>
    </div>
  </div>

</section>

      

      
    </div>
  )
}

export default Forgot_password
